export const resolveInstanceId = (workerId: string) => {
  const colonIndex = workerId.indexOf(':')
  return colonIndex === -1 ? workerId : workerId.slice(0, colonIndex)
}

export const resolveWorkerLabel = (workerId: string, groupedByInstance: boolean) => {
  if (!groupedByInstance) return workerId

  const colonIndex = workerId.indexOf(':')
  return colonIndex === -1 ? workerId : workerId.slice(colonIndex + 1)
}

export const groupWorkersByInstance = <T extends { workerId: string }>(workers: T[]) => {
  const groups = new Map<string, T[]>()

  for (const worker of workers) {
    const instanceId = resolveInstanceId(worker.workerId)
    const instanceWorkers = groups.get(instanceId) || []
    instanceWorkers.push(worker)
    groups.set(instanceId, instanceWorkers)
  }

  return Array.from(groups.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([instanceId, instanceWorkers]) => ({
      instanceId,
      workers: instanceWorkers.sort((a, b) => a.workerId.localeCompare(b.workerId)),
    }))
}
